import axios from 'axios'
import ENV from '../env'
import { log } from '../helpers/logger'
import { detectIE } from '../helpers/util'
import {BFF_COOKIE_HEADER, YETTEL_ACCOUNT_COOKIE} from "../constants/CookieConstants";
import {getCookie} from "../helpers/cookies";
const http = () => {
  const request = options => {
    if (!options.url) throw new Error('url is required')

    options.baseURL = ENV.api.base_url
    options.method = options.method || 'get'

    options.headers = {}

    if (options.method === 'post' || options.method === 'put') {
      options.headers['Content-Type'] = 'application/json'
    }

    const cookieToken = getCookie(YETTEL_ACCOUNT_COOKIE);

    if (cookieToken) {
      options.headers[BFF_COOKIE_HEADER] = cookieToken;
    }

    // Deal with IE aggressive caching
    // http://stackoverflow.com/questions/2848945/prevent-ie-caching
    if (detectIE() && options.method === 'get') {
      options.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate'
      options.headers['Pragma'] = 'no-cache'
      options.headers['Expires'] = '0'
    }

    log('api', `${options.method.toUpperCase()} ${options.url} ${options.params ? JSON.stringify(options.params) : ''} ==>`, options.data)

    return axios(options).then(res => {
      // log('api', `${options.method.toUpperCase()} ${options.url} <==`, res);
      return res.data
    }).catch(res => {
      let err = 'Server unavailable!'
      let response = res.response
      if (response && response.data && response.data.message) {
        err = response.data.message
      }
      throw err
    })
  }

  const get = (url, params) => request({url, params})

  const post = (url, params, data) => request({method: 'post', url, params, data})

  const put = (url, params, data) => request({method: 'put', url, params, data})

  const del = (url, params, data) => request({method: 'delete', url, params, data})

  const head = (url, params) => request({method: 'head', url, params})

  return {request, get, post, put, del, head}
}

export default http

